import { Component, Input } from '@angular/core';
import { UnfinishedBookingData } from '../../../models/interfaces/UnfinishedBookingData.interface';
import { StateService } from '../../../services/state/state.service';
import { NavigationService } from '../../../services/navigation/navigation.service';

@Component({
  selector: 'app-button-bar-for-continue-booking',
  templateUrl: './button-bar-for-continue-booking.component.html',
  styleUrls: ['./button-bar-for-continue-booking.component.scss'],
})
export class ButtonBarForContinueBookingComponent {
  @Input() data: UnfinishedBookingData;

  public isAbleToCancelProgress = 0;

  constructor(
    private stateService: StateService,
    private navigationService: NavigationService
  ) {
    this.calculateAbleToCancelProgress();
  }

  public continueBooking(): void {
    if (!this.data?.bookingConfigUrl) {
      return;
    }

    this.navigationService.redirectToUrl(this.data.bookingConfigUrl);
  }

  public isAbleToCancel(): boolean {
    return this.isAbleToCancelProgress >= 100;
  }

  public cancelUnfinishedBooking(): void {
    if (!this.isAbleToCancel()) {
      return;
    }

    this.stateService.setUnfinishedBookingData(null);
  }

  private calculateAbleToCancelProgress(): void {
    const timeToCancelMs = 3 * 1000;

    const tickMs = timeToCancelMs / 100;

    const interval = setInterval(() => {
      if (this.isAbleToCancelProgress >= 100) {
        clearInterval(interval);
      } else {
        this.isAbleToCancelProgress += 1;
      }
    }, tickMs);
  }
}
